/**
 * Parses the date of birth encoded in the first 6 digits of a South African ID number.
 * RSA ID format: YYMMDD followed by 7 more digits (13 total).
 */
export function parseRsaIdDob(idNumber: string): string | null {
  if (idNumber.length < 6) return null

  const yy = parseInt(idNumber.slice(0, 2), 10)
  const mm = parseInt(idNumber.slice(2, 4), 10)
  const dd = parseInt(idNumber.slice(4, 6), 10)

  if (isNaN(yy) || isNaN(mm) || isNaN(dd)) return null

  // Century rule: YY <= current 2-digit year → 2000s, else → 1900s
  const currentYY = new Date().getFullYear() % 100
  const yyyy = yy <= currentYY ? 2000 + yy : 1900 + yy

  // Validate it is a real calendar date
  const date = new Date(yyyy, mm - 1, dd)
  if (
    date.getFullYear() !== yyyy ||
    date.getMonth() !== mm - 1 ||
    date.getDate() !== dd
  ) {
    return null
  }

  const mmStr = String(mm).padStart(2, "0")
  const ddStr = String(dd).padStart(2, "0")
  return `${yyyy}-${mmStr}-${ddStr}`
}
